import { render, staticRenderFns } from "./regionRow.vue?vue&type=template&id=57f3de58"
import script from "./regionRow.ts?vue&type=script&lang=ts&external"
export * from "./regionRow.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports